import { __assign, __awaiter, __generator, __read } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { queryCache, useMutation, } from '@office-start/data-fetching';
import { fetchIdentity } from '@office-start/identity-service';
import { getQueryKey } from '../getQueryKey';
import { setUserStorageItem } from '../operations/setUserStorageItem';
export function useUpdateUserStorage(storageKey, update) {
    var _this = this;
    var queryKey = getQueryKey(storageKey);
    return useMutation(function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, officeComponentContext, identity, options, newValue;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        fetchOfficeComponentContext(),
                        fetchIdentity(),
                    ])];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 2]), officeComponentContext = _a[0], identity = _a[1];
                    options = {
                        correlationId: officeComponentContext.correlationId,
                        getAccessToken: officeComponentContext.getAccessToken,
                        getIdentity: function () { return Promise.resolve(identity); },
                        inMockMode: officeComponentContext.inMockMode,
                        jwtAuthEnabled: officeComponentContext.jwtAuthEnabled,
                        officeHomeApiRoot: officeComponentContext.officeHomeApiRoot,
                        workload: officeComponentContext.workload,
                    };
                    newValue = queryCache.getQueryData(queryKey);
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return [2 /*return*/, (newValue &&
                            setUserStorageItem(storageKey, newValue.result, options))];
            }
        });
    }); }, {
        onMutate: function (vars) {
            queryCache.cancelQueries(queryKey);
            var previousValue = queryCache.getQueryData(queryKey);
            var newValue = update(previousValue && __assign({}, previousValue.result), vars);
            // Try to update optimistically
            queryCache.setQueryData(queryKey, {
                result: newValue,
                fromPersistence: !!(previousValue === null || previousValue === void 0 ? void 0 : previousValue.fromPersistence),
            });
            return previousValue;
        },
        onError: function (_err, _vars, previousValue) {
            // roll back the optimistic update in case of error
            queryCache.setQueryData(queryKey, previousValue);
        },
    });
}
//# sourceMappingURL=useUpdateUserStorage.js.map